"use client";
import { Tab, Tabs } from "@fanduel/formation-react-components";
import cx from "classnames";
import { HEAD_TO_HEAD_TAB_VIEWED } from "@/constants/amplitude";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import { useTabInfo } from "@/utils/hooks/useTabsContext";
import style from "./styles.module.scss";

interface HeadToHeadTabsProps {
  tabs: { label: string; value: string }[];
  align?: "center" | "left";
}

export default function HeadToHeadTabs({
  tabs,
  align = "left",
}: HeadToHeadTabsProps) {
  const { activeTab, setActiveTab } = useTabInfo();
  const tabsClasses = cx(style.tabs, {
    [style.center]: align === "center",
    [style.left]: align === "left",
  });
  const { logAmplitudeEvent } = useAmplitude();
  const { eventName } = useHeadToHeadContext();
  const handleTabSelect = (tabId: string) => {
    logAmplitudeEvent(HEAD_TO_HEAD_TAB_VIEWED, {
      "Event Name": eventName,
      Tab: tabId,
    });
    if (setActiveTab) {
      setActiveTab(tabId);
    }
  };

  return (
    <Tabs
      className={tabsClasses}
      onTabSelect={handleTabSelect}
      selectedTab={activeTab}
    >
      {tabs.map((tab) => (
        <Tab key={tab.value} id={tab.value}>
          {tab.label}
        </Tab>
      ))}
    </Tabs>
  );
}
